<main class="home-container">
  <div class="main-section">
    <img src="/logos/logo2.jpg" alt="DESP Logo" class="logo" />
    <h1 class="main-title">{{titleText}}</h1>
    <p class="description">{{descriptionText1}}</p>
    <p class="description">{{descriptionText2}}</p>
    <p class="description">{{descriptionText3}}</p>
    <button class="desp-button homepage-button" (click)="goToNotebookList()">{{buttonText}}</button>
  </div>
</main>
